import React, { useEffect, useState } from 'react';
import moment from 'moment/moment';
import { IQC_REGISTRATION_OPEN_DATE } from './constants';
import { useIntl } from 'react-intl';
import { formatMessageHelper } from '../../shared/helpers/internationalization';

type TimeLeft = {
  months: number;
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};

const getTime = (targetDate: Date) => {
  const duration = moment.duration(moment(targetDate).diff(moment()));

  return {
    months: duration.months(),
    days: duration.days(),
    hours: duration.hours(),
    minutes: duration.minutes(),
    seconds: duration.seconds(),
  };
};
export const useCountdown = (props: { targetDate: Date }) => {
  const { targetDate } = props;
  const [time, setTime] = useState<TimeLeft>(getTime(targetDate));

  useEffect(() => {
    const interval = setInterval(() => {
      const time = getTime(targetDate);

      setTime(time);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [targetDate]);

  return time;
};
export const Countdown = () => {
  const intl = useIntl();
  const { months, days, hours, minutes, seconds } = useCountdown({ targetDate: IQC_REGISTRATION_OPEN_DATE });

  return (
    <div className="iqc-countdown">
      {months > 0 && <CountdownCell value={months} label="Months" />}
      <CountdownCell value={days} label={formatMessageHelper(intl, 'countdown.days')} />
      <CountdownCell value={hours} label={formatMessageHelper(intl, 'countdown.hours')} />
      <CountdownCell value={minutes} label={formatMessageHelper(intl, 'countdown.minutes')} />
      <CountdownCell value={seconds} label={formatMessageHelper(intl, 'countdown.seconds')} />
    </div>
  );
};
const CountdownCell = ({ value, label }: { value: number; label: string }) => {
  return (
    <div className="iqc-countdown-cell">
      <div className="iqc-countdown-cell__value">{value.toString(10).padStart(2, '0')}</div>
      <div className="iqc-countdown-cell__label">{label}</div>
    </div>
  );
};
